module.exports = __webpack_public_path__ + "static/media/logout.390e328b.svg";